var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNormalTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tick-a",
    d: "M9.11360237,18.697808 L3.26360258,12.8478082 C2.91214392,12.4963496 2.91214392,11.9265038 3.26360258,11.5750108 L4.53636566,10.3022134 C4.88782433,9.95072043 5.45770441,9.95072043 5.80916307,10.3022134 L9.74998391,14.2430343 L18.190794,5.80222415 C18.5422527,5.45076549 19.1121328,5.45076549 19.4635914,5.80222415 L20.7363545,7.07502156 C21.0878132,7.42648023 21.0878132,7.99632598 20.7363545,8.34781898 L10.3863654,18.6978424 C10.0348724,19.049301 9.4650267,19.049301 9.11360237,18.697808 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#40B3DB",
    xlinkHref: "#tick-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalTick);
export default __webpack_public_path__ + "static/media/normal-tick.10af3de3.svg";
export { ForwardRef as ReactComponent };